import React from "react";
import "./Navbar.css";
import logo from "../assets/logo.png";

const Navbar = () => {
  return (
    <header className="navbar container">
      {/* Left side: Logo and text */}
      <div className="navbar-logo">
        <img src={logo} alt="Thaani Logo" />
      </div>

      {/* Right side: Links and Button */}
      <nav className="navbar-links">
        <a href="#">Franchise</a>
        <button className="contact-btn">Contact us</button>
      </nav>
    </header>
  );
};

export default Navbar;
